import React, { useMemo, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooter,
  InputTextMaster,
  MasterButton,
  Modal,
  SearchInput,
  TableHeader,
  TableToolbar,
} from "App/Component/ui";

import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Grid, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const rows = [
  {
    id: "1",
    name: "Umum",
    inserted_ip: "192.168.100.67",
    inserted_time: "02/05/2021 16:20",
    inserted_by: "Kholida",
    updated_ip: "192.168.100.57",
    updated_time: "02/06/2021 18:30",
    updated_by: "Kholida",
  },
  {
    id: "3",
    name: "Dokter",
    inserted_ip: "192.168.100.67",
    inserted_time: "02/05/2021 16:20",
    inserted_by: "Kholida",
    updated_ip: "192.168.100.57",
    updated_time: "02/06/2021 18:30",
    updated_by: "Kholida",
  },
  {
    id: "56",
    name: "Perujuk",
    inserted_ip: "192.168.100.67",
    inserted_time: "02/05/2021 16:20",
    inserted_by: "Kholida",
    updated_ip: "192.168.100.57",
    updated_time: "02/06/2021 18:30",
    updated_by: "Kholida",
  },
];

// sorted not work because diferent id with data
const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "INFO",
    align: "left",
  },
  { id: "inserted_ip", disablePadding: false, label: "INSERTED IP" },
  { id: "inserted_time", disablePadding: false, label: "INSERTED TIME" },
  { id: "inserted_by", disablePadding: false, label: "INSERTED BY" },
  { id: "updated_ip", disablePadding: false, label: "UPDATED IP" },
  { id: "updated_time", disablePadding: false, label: "UPDATED TIME" },
  { id: "updated_by", disablePadding: false, label: "UPDATED BY" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "97%",
    margin: "0 auto",
  },
}));

let PageSize = 10;

export default function TipeKaryawan() {
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);
  const [showModal, setShowModal] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useMemo(() => {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return rows.slice(firstPageIndex, lastPageIndex);
  }, [page]);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const modalCreate = () => {
    return (
      <Modal title={"Tambah Tipe Karyawan"} show={() => setShowModal(false)}>
        <InputTextMaster
          name='tipe_karyawan'
          label='Tipe Karyawan'
          id='tipe_karyawan'
          placeholder='Tipe Karyawan'
          className='mt-05'
        />
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            disabled={true}
            className={"mt-1"}
            type={"submit"}
            color='green'
            name='Simpan'
            size='md'
          />
        </Grid>
      </Modal>
    );
  };

  return (
    <div className={classes.root}>
      {showModal && modalCreate()}
      <Paper className={classes.paper}>
        <TableToolbar title={"Daftar Tipe Karyawan"}>
          <SearchInput withIcon={true} onchange={onchange} />
          <MasterButton
            outline={true}
            type={"submit"}
            color='green'
            name='Cari'
            size='md'
          />
          <MasterButton
            type={"submit"}
            color='green'
            name='Tambah'
            size='md'
            onClick={() => setShowModal(!showModal)}
          />
          <MasterButton
            type={"submit"}
            color='warning'
            name='Export'
            size='md'
          />
        </TableToolbar>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby='tableTitle'
            size={"medium"}
            aria-label='enhanced table'>
            <TableHeader
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={headCells}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}>
                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        {index + 1}
                      </TableCell>

                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        <IconButton color='secondary' aria-label='delete'>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>

                      <TableCell align='left'>{row.id}</TableCell>

                      <TableCell align='left'>{row.name}</TableCell>
                      <TableCell align='left'>{row.inserted_ip}</TableCell>
                      <TableCell align='left'>{row.inserted_time}</TableCell>
                      <TableCell align='left'>{row.inserted_by}</TableCell>
                      <TableCell align='left'>{row.updated_ip}</TableCell>
                      <TableCell align='left'>{row.updated_time}</TableCell>
                      <TableCell align='left'>{row.updated_by}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow>
                  <TableCell align='center' colSpan={6}></TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <DatatablesFooter
          page={page}
          length={rows.length}
          rowsPerPage={rowsPerPage}
          selectRows={[10, 20]}
          onPageChange={(page) => setPage(page - 1)}
          onSelectChange={(e) => setRowsPerPage(e.target.value)}
        />
      </Paper>
    </div>
  );
}
